module.exports = __webpack_public_path__ + "img/dislike.0a89cf92.png";